export const taskStatuses = {
  completed: {
    color: '#54CC7C',
    label: 'Completed',
  },
  pending: {
    color: '#38AEC2',
    label: 'Pending',
  },
  overdue: {
    color: '#D00606',
    label: 'Overdue',
  },
  stalled: {
    color: '#506A85',
    label: 'Stalled',
  },
  in_progress: {
    color: '#FDC52B',
    label: 'In Progress',
  },
};

export const statusOptions = [
  { label: 'Pending', value: 'pending' },
  { label: 'Stalled', value: 'stalled' },
  { label: 'Overdue', value: 'overdue' },
  { label: 'Completed', value: 'completed' },
  { label: 'In Progress', value: 'in_progress' },
];
